import { Component } from "@angular/core";
import { BaseInsuranceComponent } from "../base/base.component";
import { NxAccordionModule } from "@aposin/ng-aquila/accordion";
import { ResultItemComponent } from "../../result-item/result-item.component";
import { TranslationComponent } from "../../translation/translation.component";

@Component({
  selector: "app-building-insurance",
  standalone: true,
  imports: [NxAccordionModule, ResultItemComponent, TranslationComponent],
  templateUrl: "./building-insurance.component.html",
  styleUrl: "./building-insurance.component.css",
})
export class BuildingInsuranceComponent extends BaseInsuranceComponent {}
